import Button from "../../../../Custom/Button/Button";
import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import VazecaTabela from "./VazecaTabela";
import ArhiviranaTabela from "./ArhiviranaTabela";
import axios from "axios";

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold",
    width: "17vw",
    height: "5vh"
  }
};

function PrvaPomoc() {
  const [vazecaDokumenta, setVazecaDokumenta] = useState([]);
  const [arhiviranaDokumenta, setArhiviranaDokumenta] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [checkedRowsVazeci, setCheckedRowsVazeci] = useState([]);
  const [isCheckedAllVazeci, setIsCheckedAllVazeci] = useState(false);

  const [checkedRowsArhivirani, setCheckedRowsArhivirani] = useState([]);
  const [isCheckedAllArhivirani, setIsCheckedAllArhivirani] = useState(false);

  const { dictionary, loggedUser, apiKey, selectedMainEntity, baseUrl } = useGlobalContext();

  const company_id = selectedMainEntity?.company_id;

  const formatDatum = (datum) => {
    if (!datum) return "";
    const d = new Date(datum);
    if (isNaN(d)) return datum;
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}.${mm}.${yyyy}`;
  };

  const toColor = (path) => (path ? "green" : "");

  const mapDokument = (d) => ({
    id: d.id,
    nazivDokumenta: d.naziv,
    brojDokumenta: d.broj,
    tip: d.tip,
    word: toColor(d.word),
    pdf: toColor(d.pdf),
    image: toColor(d.image),
    scan: toColor(d.scan),
    wordPath: d.word,
    pdfPath: d.pdf,
    imagePath: d.image,
    scanPath: d.scan,
    datum: formatDatum(d.datum_isteka),
    arhiviran: d.arhiviran,
    created_at: d.created_at
  });

  const fetchDokumenta = async () => {
    if (!company_id || !loggedUser?.id || !apiKey) return;

    setIsLoading(true);
    try {
      const { data } = await axios.post(`${baseUrl}/prva_pomoc/read.php`, {
        user_id: loggedUser.id,
        api_key: apiKey,
        company_id
      });

      if (data.status === 200) {
        setVazecaDokumenta(data.vazeca.map(mapDokument));
        setArhiviranaDokumenta(data.arhivirana.map(mapDokument));
      } else {
        console.error("Greška pri učitavanju:", data.message);
      }
    } catch (e) {
      console.error("Greška pri učitavanju dokumenata:", e);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchDokumenta();
  }, [company_id]);

  const moveToArhivirani = async (dokument) => {
    try {
      const { data } = await axios.post(`${baseUrl}/prva_pomoc/archive.php`, {
        user_id: loggedUser.id,
        api_key: apiKey,
        id: dokument.id,
        arhiviran: 1
      });
      if (data.status === 200) {
        setArhiviranaDokumenta((prev) => [...prev, { ...dokument, arhiviran: 1 }]);
        setVazecaDokumenta((prev) => prev.filter((dok) => dok.id !== dokument.id));
      } else {
        console.error("Greška pri arhiviranju:", data.message);
      }
    } catch (e) {
      console.error("Greška pri arhiviranju:", e);
    }
  };

  const moveToVazeci = async (dokument) => {
    try {
      const { data } = await axios.post(`${baseUrl}/prva_pomoc/archive.php`, {
        user_id: loggedUser.id,
        api_key: apiKey,
        id: dokument.id,
        arhiviran: 0
      });
      if (data.status === 200) {
        setVazecaDokumenta((prev) => [...prev, { ...dokument, arhiviran: 0 }]);
        setArhiviranaDokumenta((prev) => prev.filter((dok) => dok.id !== dokument.id));
      } else {
        console.error("Greška pri razarhiviranju:", data.message);
      }
    } catch (e) {
      console.error("Greška pri razarhiviranju:", e);
    }
  };

  // id — id dokumenta, tipFajla — "word"/"pdf"/"image"/"scan" ili "" za ceo dokument
  const handleDelete = async (id, tipFajla = "") => {
    try {
      const { data } = await axios.post(`${baseUrl}/prva_pomoc/delete.php`, {
        user_id: loggedUser.id,
        api_key: apiKey,
        id,
        ...(tipFajla && { tip_fajla: tipFajla })
      });
      if (data.status === 200) {
        if (tipFajla) {
          // Brisanje jedne verzije — samo resetuj boju te kolone
          const resetVerziju = (prev) =>
            prev.map((dok) =>
              dok.id === id ? { ...dok, [tipFajla]: "", [`${tipFajla}Path`]: "" } : dok
            );
          setVazecaDokumenta(resetVerziju);
          setArhiviranaDokumenta(resetVerziju);
        } else {
          // Brisanje celog dokumenta
          setVazecaDokumenta((prev) => prev.filter((dok) => dok.id !== id));
          setArhiviranaDokumenta((prev) => prev.filter((dok) => dok.id !== id));
        }
      } else {
        console.error("Greška pri brisanju:", data.message);
      }
    } catch (e) {
      console.error("Greška pri brisanju:", e);
    }
  };

  const handleDodaj = () => {
    const globalnoDodavanjeInput = document.getElementById(
      "globalno-dodavanje-input"
    );
    if (!globalnoDodavanjeInput) return;
    globalnoDodavanjeInput.value = "";
    globalnoDodavanjeInput.click();
  };

  if (isLoading) return <div style={{ padding: "20px" }}>Učitavanje...</div>;

  return (
    <div
      style={{
        padding: "5px",
        backgroundColor: "rgb(204, 204, 204)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}
    >
      <div
        style={{
          overflowY: "auto",
          backgroundColor: "white",
          border: "1.5px solid #9f9f9f",
          padding: "5px",
          height: "100%"
        }}
      >
        <VazecaTabela
          dokumenta={vazecaDokumenta}
          setDokumenta={setVazecaDokumenta}
          moveToArhivirani={moveToArhivirani}
          checkedRows={checkedRowsVazeci}
          setCheckedRows={setCheckedRowsVazeci}
          isCheckedAll={isCheckedAllVazeci}
          setIsCheckedAll={setIsCheckedAllVazeci}
        />

        <div style={{ marginTop: "5px" }}>
          <ArhiviranaTabela
            dokumenta={arhiviranaDokumenta}
            setDokumenta={setArhiviranaDokumenta}
            moveToVazeci={moveToVazeci}
            handleDelete={handleDelete}
            checkedRows={checkedRowsArhivirani}
            setCheckedRows={setCheckedRowsArhivirani}
            isCheckedAll={isCheckedAllArhivirani}
            setIsCheckedAll={setIsCheckedAllArhivirani}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "15px"
        }}
      >
        <div style={{ display: "flex", gap: "10px" }}>
          <div>
            <Button activation={true} style={styles.button}>
              {dictionary["stampaj"]}
            </Button>
          </div>
          <div>
            <Button activation={true} style={styles.button}>
              {dictionary["posalji"]}
            </Button>
          </div>
        </div>
        <div onClick={handleDodaj}>
          <Button activation={true} style={styles.button}>
            {dictionary["dodajNoviDokument"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PrvaPomoc;